var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-mail",
    transform: "translate(-0.264 -0.264)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_41",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 41"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_12",
    "data-name": "\\u9577\\u65B9\\u5F62 12",
    width: 24,
    height: 24,
    transform: "translate(0.264 0.264)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_43",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 43",
    transform: "translate(3.679 4.906)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_42",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_33",
    "data-name": "\\u30D1\\u30B9 33",
    d: "M20.117,15.172a4.9,4.9,0,0,1,2.453.675V8.426A1.23,1.23,0,0,0,21.343,7.2H6.626A1.23,1.23,0,0,0,5.4,8.426V20.69a1.23,1.23,0,0,0,1.226,1.226h8.953a4.827,4.827,0,0,1-.368-1.84A4.9,4.9,0,0,1,20.117,15.172Zm-13.49-5.3V8.426l7.358,4.6,7.358-4.6V9.874l-7.358,4.6Z",
    transform: "translate(-5.4 -7.2)",
    fill: "#5b87b4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_34",
    "data-name": "\\u30D1\\u30B9 34",
    d: "M25.488,21.006l-.871.871,2,1.987H21.6V25.09h5.016l-2,1.987.871.871,3.471-3.471Z",
    transform: "translate(-10.562 -11.6)",
    fill: "#5b87b4"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon-mail.0beed911e8466c18d80b3c3ccd82b4a6.svg";
export { ForwardRef as ReactComponent };